module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.rowData.name))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12 pull-right"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-7 col-xs-12"
  }, [_c('figure', {
    staticClass: "pic"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": 'https://files.i80.com.tw/images/product/' + _vm.rowData.imageL
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5 col-xs-12"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.rowData.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.rowData.short))]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled product_intro"
  }, [_c('li', {
    staticClass: "price_box"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.rowData.price))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(3, false, false), _vm._v(" "), _c('li', [_c('b', {
    staticClass: "title"
  }, [_vm._v("數量")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderNumber),
      expression: "orderNumber"
    }],
    staticClass: "form-control amount",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.orderNumber = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.numbers), function(number) {
    return _c('option', {
      domProps: {
        "value": number
      }
    }, [_vm._v(_vm._s(number))])
  }))])]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addToCart(_vm.rowData)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-shopping-cart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 加入購物車\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "fb-like",
    attrs: {
      "data-href": 'https://www.i80.com.tw/product/' + _vm.rowData.id,
      "data-share": "true",
      "data-width": "120",
      "data-show-faces": "false"
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "title"
  }, [_vm._v("產品介紹")]), _vm._v(" "), _c('p', {
    staticClass: "editor",
    domProps: {
      "innerHTML": _vm._s(_vm.rowData.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fb-comments",
    attrs: {
      "data-href": "this.id",
      "data-num-posts": "2",
      "data-width": "100%"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {}, [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/product"
    }
  }, [_vm._v("購物商城")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('b', {
    staticClass: "title"
  }, [_vm._v("付款方式")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled list-inline payment"
  }, [_c('li', [_vm._v("信用卡")]), _vm._v(" "), _c('li', [_vm._v("ATM")]), _vm._v(" "), _c('li', [_vm._v("iBon")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12468afc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GoodPrice.vue
// module id = 282
// module chunks = 1